import type { QuickSearchGroup } from '../types/group';
import type { QuickSearchItem } from '../types/item';

export type QuickSearchGroupedItems = {
  group?: QuickSearchGroup;
  items: QuickSearchItem[];
}[];

export function groupQuickSearchItems(
  items: QuickSearchItem[]
): QuickSearchGroupedItems {
  const groups: QuickSearchGroupedItems = [];

  for (const item of items) {
    const group = item.group;
    const existingGroup = groups.find(g => g.group?.id === group?.id);
    if (existingGroup) {
      existingGroup.items.push(item);
    } else {
      groups.push({ group, items: [item] });
    }
  }

  for (const { items } of groups) {
    // Doc result groups arrive ordered; their rows stay together.
    if (items.some(item => item.row)) continue;
    items.sort((a, b) => (b.score ?? 0) - (a.score ?? 0));
  }

  groups.sort((a, b) => {
    const group = (b.group?.score ?? 0) - (a.group?.score ?? 0);
    if (group !== 0) {
      return group;
    }
    return (b.items[0].score ?? 0) - (a.items[0].score ?? 0);
  });

  return groups;
}
